<section class="icon-wall-container">
  <div class="icon-wall-content">
    <div *ngFor="let icon of icons" class="icon-container">
      <img class="company-icon" src="{{ icon.svg }}" title="{{ icon.title }}" alt="{{ icon.alt }}" />
    </div>
  </div>
  <div class="icon-wall-content-mobile">
    <div *ngFor="let icon of mobileIcons | slice: 0:1" class="icon-container">
      <img class="company-icon" src="{{ icon.svg }}" title="{{ icon.title }}" alt="{{ icon.alt }}" />
    </div>
    <div class="x-by-two-container">
      <div  *ngFor="let icon of mobileIcons | slice: 1"  class="icon-container">
        <img class="company-icon" src="{{ icon.svg }}" title="{{ icon.title }}" alt="{{ icon.alt }}" />
      </div>
    </div>
  </div>
</section>
